import React from 'react'

const ErrorCircle = () => {
  return (
    <svg
      data-testid="icon-error-circle"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.7168 15.2832L15.2834 24.7165"
        stroke="#DE1212"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.7168 24.7165L15.2834 15.2832"
        stroke="#DE1212"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 35C16.0218 35 12.2064 33.4196 9.3934 30.6066C6.58035 27.7936 5 23.9782 5 20C5 16.0218 6.58035 12.2064 9.3934 9.3934C12.2064 6.58035 16.0218 5 20 5C23.9782 5 27.7936 6.58035 30.6066 9.3934C33.4196 12.2064 35 16.0218 35 20C35 23.9782 33.4196 27.7936 30.6066 30.6066C27.7936 33.4196 23.9782 35 20 35V35Z"
        stroke="#DE1212"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { ErrorCircle }
